import React from 'react';
import { Box, Accordion } from '@rsos/components/capstone/base';
import {
  fetchAccordionTitle,
  fetchAccordionContent,
  fetchAccordionHeader,
  fetchCustomAccordionStyle,
  fetchDataName,
} from './helpers';

const CustomAccordion = props => {
  const { schema, ownData, children, incidentType } = props;
  return (
    <Box px={20} pt={20}>
      {fetchAccordionTitle(incidentType, schema.title)}
      <Box mt={16} flow={10}>
        {ownData.length > 0 &&
          ownData.map((unit, index) => {
            const newProps = { ...props, children: children[index] };
            return (
              <Accordion
                headerPadding="13px 15px"
                headerIcon="chevron"
                key={index}
                dataName={fetchDataName(incidentType)}
                style={fetchCustomAccordionStyle(incidentType)}
                header={fetchAccordionHeader(incidentType, unit)}
                interactionType="button"
                height={250}
                width="100%"
                content={fetchAccordionContent(incidentType, newProps)}
              ></Accordion>
            );
          })}
      </Box>
    </Box>
  );
};

export default CustomAccordion;
